<template>
    <div name="faq" class="faq" id="accordion">
        <div class="faq-inner">
            <button type="button" class="faq-card" @click="selectContents(1)">
                <strong class="card-title">
                    솔닥파트너스 가입 절차가 어떻게 되나요?
                </strong>
                <img
                    style="width: 12px"
                    v-if="selected !== 1"
                    src="../../assets/partners_pc/ico_plus.png"
                    alt="열기"
                />
                <img
                    style="width: 12px"
                    v-else
                    src="../../assets/partners_pc/ico_minus.png"
                    alt="닫기"
                />
            </button>
            <div class="faq-content" v-if="selected === 1">
                솔닥파트너스는 페이지 내 [ 무료 가입하기 ]를 통해 직접 가입을
                진행할 수 있으며 약 2 영업일 내 솔닥에서 정보 확인 후 가입이
                최종 승인됩니다. 가입 전 추가 상담이 필요하시다면 하단 [
                문의하기 ] 로 문의 부탁드립니다.
            </div>
            <button type="button" class="faq-card" @click="selectContents(2)">
                <strong class="card-title">
                    솔닥파트너스는 어떤 의료기관에서 사용이 가능한가요?
                </strong>
                <img
                    style="width: 12px"
                    v-if="selected !== 2"
                    src="../../assets/partners_pc/ico_plus.png"
                    alt="열기"
                />
                <img
                    style="width: 12px"
                    v-else
                    src="../../assets/partners_pc/ico_minus.png"
                    alt="닫기"
                />
            </button>
            <div class="faq-content" v-if="selected === 2">
                모든 의료기관에서 사용 가능합니다.
            </div>
            <button type="button" class="faq-card" @click="selectContents(3)">
                <strong class="card-title">
                    비용은 어떻게 되나요?
                </strong>
                <img
                    style="width: 12px"
                    v-if="selected !== 3"
                    src="../../assets/partners_pc/ico_plus.png"
                    alt="열기"
                />
                <img
                    style="width: 12px"
                    v-else
                    src="../../assets/partners_pc/ico_minus.png"
                    alt="닫기"
                />
            </button>
            <div type="button" class="faq-content" v-if="selected === 3">
                현재 모든 가입자 무료 프로모션 진행 중이며, 추후 비용 업데이트
                시 안내드리겠습니다.
            </div>
            <button type="button" class="faq-card" @click="selectContents(4)">
                <strong class="card-title"> 가입 조건이 따로 있나요?</strong>
                <img
                    style="width: 12px; margin-left: 10px;"
                    v-if="selected !== 4"
                    src="../../assets/partners_pc/ico_plus.png"
                    alt="열기"
                />
                <img
                    style="width: 12px; margin-left: 10px;"
                    v-else
                    src="../../assets/partners_pc/ico_minus.png"
                    alt="닫기"
                />
            </button>
            <div class="faq-content" v-if="selected === 4">
                현재 병&#183;의원 또는 약국을 운영하고 있는 의사선생님,
                약사님이라면 모두 가입 가능합니다.
            </div>

            <button type="button" class="faq-card" @click="selectContents(5)">
                <strong class="card-title">
                    보다 자세한 이용 방법이 궁금해요.</strong
                >
                <img
                    style="width: 12px; margin-left: 10px;"
                    v-if="selected !== 5"
                    src="../../assets/partners_pc/ico_plus.png"
                    alt="열기"
                />
                <img
                    style="width: 12px; margin-left: 10px;"
                    v-else
                    src="../../assets/partners_pc/ico_minus.png"
                    alt="닫기"
                />
            </button>
            <div class="faq-content" v-if="selected === 5">
                솔루션 이용 방법은 가입완료 후 전달드리는 이용가이드를 참고해
                주시기 바랍니다. 서비스에 대한 더 자세한 안내가 필요하다면
                [문의하기]에 연락처 정보를 남겨주시거나, 솔닥파트너스 전담
                고객센터로 연락주세요. 친절히 상담드리겠습니다. (고객센터
                전화번호: 02-6954-7676)
            </div>
        </div>
        <a
            href="https://soldoc.channel.io/home"
            target="_blank"
            title="새창으로 열림"
            class="btn-faq"
            >문의하기</a
        >
    </div>
</template>

<script>
export default {
    name: "faq",
    data: function() {
        return {
            selected: 1,
        };
    },
    methods: {
        selectContents: function(index) {
            if (this.selected != index) {
                this.selected = index;
            } else {
                this.selected = 0;
            }
        },
        goFaq: function() {
            window.open("https://soldocfaq.oopy.io/", "_blank");
        },
    },
};
</script>

<style scoped>
.faq {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    width: 100%;
    background: #1a1a1a;
    padding: 146px 20px 82px;
}
.faq-inner {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    border-bottom: 1px solid #9da0a4;
}

.in {
    margin-left: 30px;
}

.faq .btn-faq {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 150px;
    height: 46px;
    margin-top: 44px;
    border: 1px solid #fff;
    border-radius: 6px;
    background: transparent;
    font-size: 16px;
    font-weight: 600;
    line-height: 34px;
    color: #fff;
    text-align: center;
}
.faq .btn-faq:hover {
    text-decoration: none;
}

.faq-inner .faq-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 58px;
    border: none;
    border-top: 1px solid #9da0a4;
    background: none;
    font-size: 20px;
    font-weight: 400;
    line-height: 40px;
    color: #fff;
}
.faq-inner .card-title {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    text-align: left;
}

.faq-inner .faq-content {
    width: 100%;
    padding: 15px;
    border-radius: 10px;
    margin-bottom: 17px;
    background: #2c2e2f;
    font-size: 14px;
    font-weight: 400;
    line-height: 25px;
    color: #fff;
    animation: fadeInUp 0.1s;
}
.line {
    width: 100%;
    height: 1px;
    background: #9da0a4;
}

@keyframes fadeInUp {
    0% {
        opacity: 0;
        height: 0;
    }
    to {
        opacity: 1;
        height: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile_partners/FaQ.vue